// @ts-ignore
import * as FocusTrap from 'focus-trap';
export class MainNavigation {
    button: HTMLElement;
    navigation: HTMLElement;
    activeClass: string;
    visibleClass: string;
    scrollableClass: string;
    header: HTMLElement;
    private trap?: FocusTrap.FocusTrap;

    constructor() {
        this.activeClass = 'is-active';
        this.visibleClass = 'is-visible';
        this.scrollableClass = 'is-scrollable';
        this.button = document.querySelector('[data-main-navigation="button"]');
        this.navigation = document.querySelector('[data-main-navigation="nav"]');
        this.header = document.querySelector('[data-main-navigation="header"]');

        if (this.navigation) {
            this.trap = FocusTrap.createFocusTrap(this.navigation, {
                allowOutsideClick: true,
                fallbackFocus: this.navigation
            });
        }

        this.init();
    }

    init() {
        this.addTriggerEvents();
    }

    addTriggerEvents() {
        this.button.addEventListener('click', () => {
            if (this.button.classList.contains(this.activeClass)) {
                this.closeNavigation();
            }
            else {
                this.openNavigation();
            }
        });
        document.addEventListener('click', (event: MouseEvent) => {
            this.clickOutside(event);
        });
        document.addEventListener('keydown', (event: KeyboardEvent) => {
            // Close navigation only when ESC key is pressed
            if (event.key === 'Escape') {
                this.closeNavigation();
            }
        });
    }

    clickOutside(event: MouseEvent) {
        let parents: HTMLElement[] = [
            this.button,
            this.navigation
        ];
        let clickOutside: boolean = true;
        parents.forEach((element: HTMLElement) => {
            if (element.contains(event.target as HTMLElement)) {
                clickOutside = false;
            }
        });
        if(clickOutside === true) {
            this.closeNavigation();
        }
    }

    openNavigation() {
        this.button.classList.add(this.activeClass);
        this.navigation.classList.add(this.visibleClass);
        this.navigation.style.maxHeight = this.navigation.scrollHeight + "px";
        if (window.innerHeight - this.header.clientHeight < this.navigation.scrollHeight) {
            this.navigation.classList.add(this.scrollableClass);
        }
        if (this.trap) {
            this.trap.activate();
        }
    }

    closeNavigation() {
        this.button.classList.remove(this.activeClass);
        this.navigation.classList.remove(this.visibleClass);
        this.navigation.style.maxHeight = null;
        this.navigation.classList.remove(this.scrollableClass);
        if (this.trap) {
            this.trap.deactivate();
        }
    }

}

document.addEventListener("DOMContentLoaded", function() {
    new MainNavigation();
});
